import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { Image } from './files/Image.js';
export class Sponsor extends AutoEncoder {
    id;
    url = null;
    name = '';
    logo = null;
    banner = null;
    onTickets = true;
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Sponsor.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Sponsor.prototype, "url", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Sponsor.prototype, "name", void 0);
__decorate([
    field({ decoder: Image, nullable: true })
], Sponsor.prototype, "logo", void 0);
__decorate([
    field({ decoder: Image, nullable: true, optional: true })
], Sponsor.prototype, "banner", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true })
], Sponsor.prototype, "onTickets", void 0);
export class SponsorConfig extends AutoEncoder {
    sponsors = [];
}
__decorate([
    field({ decoder: new ArrayDecoder(Sponsor) })
], SponsorConfig.prototype, "sponsors", void 0);
//# sourceMappingURL=SponsorConfig.js.map